import { ERA_LOOKS } from '@continuum/show-core';
import type { TaskDef } from '@continuum/show-core';
import { Screen } from '../../ui/Shell.js';
import { Eyebrow, Lede, Spacer } from '../../ui/atoms.js';
import { TaskQueue } from '../../ui/TaskQueue.js';
import type { QueueRow } from '../../ui/TaskQueue.js';
import type { ScreenCopy } from '../../ui/screenText.js';

/**
 * Era 3 — The War. Ordinary games like every other stop: a line about where we are, a city's broken towers
 * with embers drifting up, and the list. (Until 2026-10-24 it had sliders to "share 100 units" that counted
 * for nothing; the games are the charge.) The embers rise and fade slowly: motion, never a flash.
 */
export function War({
  rows,
  s,
  title,
  onOpen,
}: {
  rows: QueueRow[];
  s: ScreenCopy;
  title: (def: TaskDef) => string;
  onOpen: (row: QueueRow) => void;
}) {
  const look = ERA_LOOKS[3];
  const towers = [
    [8, 30], [26, 18], [40, 38], [58, 12], [76, 26], [96, 44], [114, 20], [132, 34], [150, 16], [168, 30], [184, 22],
  ] as const;
  return (
    <Screen style={{ background: 'linear-gradient(180deg,#120305,#1c0508)', color: '#ffe6e6', padding: 24 }}>
      <Eyebrow color="#ff6b78">{s.era3Eyebrow}</Eyebrow>
      <h1 style={{ margin: '12px 0 6px', fontSize: 24, fontWeight: 700, letterSpacing: 2 }}>{s.era3Title}</h1>
      <Lede color="#d49a94">{s.era3Lede}</Lede>

      <svg viewBox="0 0 200 70" style={{ display: 'block', width: '100%', maxWidth: 320, margin: '18px auto 0' }} aria-hidden="true">
        {towers.map(([x, h], i) => (
          <path key={x} d={`M${x} 64 V${64 - h} l${3 + (i % 3)} ${-(i % 2) * 4} V64 Z`} fill="#2a0a0e" stroke="rgba(255,107,120,.35)" strokeWidth="0.8" />
        ))}
        <path d="M0 64 H200" stroke="rgba(255,107,120,.5)" strokeWidth="1.2" />
        {[30, 70, 104, 140, 172].map((x, i) => (
          <circle key={x} cx={x} cy="58" r="1.4" fill={look.acc} style={{ animation: `ccEmber ${6 + i}s linear ${i * 1.3}s infinite` }} />
        ))}
      </svg>

      <TaskQueue rows={rows} look={look} s={s} title={title} onOpen={onOpen} />
      <Spacer min={12} />
    </Screen>
  );
}
